/**
 * login 登录模块
 */
import axios from '@/util/basehttp'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块


const pre = "/member/base"

const member = {
  memberListPage(pageSize, limit, keyWord) {
    return axios.get(pre + `/memberListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord
        }
    });
  },

  memberInfo(memberId) {
    return axios.get(pre + `/memberInfo`, {
      params: {
        memberId: memberId
      }
    });
  },

  memberSave(params) {
    return axios.post(pre + `/memberSave`, qs.stringify(params));
  },

  memberFollowList(memberId) {
    return axios.get(pre + `/memberFollowList`, {
      params: {
        memberId: memberId
      }
    });
  },
  saveMemberFollow(memberId, content) {
    return axios.post(pre + `/saveMemberFollow`, qs.stringify({
      memberId: memberId,
      content: content
    }));
  },
  opinionListPage(pageSize, limit, name) {
    return axios.get(pre + `/opinionListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          name: name
        }
    });
  },
  memberOpinionList(memberId) {
    return axios.get(pre + `/memberOpinionList`, {
      params: {
        memberId: memberId
      }
    });
  },
  saveMemberOpinion(memberId, content) {
    return axios.post(pre + `/saveMemberOpinion`, qs.stringify({
      memberId: memberId,
      content: content
    }));
  },

}
export default member;



// WEBPACK FOOTER //
// ./src/api/member/member.js